class ModalMenu {
  constructor(targetDOM) {
    this.initElements(targetDOM)
    this.bindEvent()

    // Clarity用: URLパラメータとハッシュで自動モーダルオープン
    const urlParams = new URLSearchParams(window.location.search)
    if (
      urlParams.get('event') === 'claritymodal' &&
      window.location.hash === '#modal-global-menu'
    ) {
      const globalMenu = document.querySelector(
        '.p-site-navigation.js-modal-menu-content'
      )
      if (globalMenu) {
        this.openModal(globalMenu)
      }
    }
  }

  // DOM要素の取得
  initElements(targetDOM) {
    this.STATE = 'is-show'
    this.MODAL_ROOT_CLOSE = 'is-modal-root-close'
    this.NO_SCROLL = 'u-noscroll'
    this.html = document.querySelector('html')
    this.body = document.querySelector('body')
    this.searchPanel = targetDOM
    this.items = Array.from(this.searchPanel.querySelectorAll('.js-modal-menu-event-item'))
    this.overlay = document.querySelector('.js-modal-menu-overlay')
  }

  // モーダルを開く
  openModal(modal) {
    modal.classList.add(this.STATE)
    this.html.classList.add(this.NO_SCROLL)
    this.body.classList.add(this.NO_SCROLL)
    this.overlay.classList.add(this.STATE)
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'global-menu', 'sp-open')
    }
  }

  // モーダルを閉じる
  closeModal(modal, isRootClose = false) {
    if (isRootClose) {
      this.html.classList.remove(this.NO_SCROLL)
      this.body.classList.remove(this.NO_SCROLL)
      this.overlay.classList.remove(this.STATE)
    }
    modal.classList.remove(this.STATE)
    // Clarity: メニュー閉じたときURLからevent=claritymodalパラメータと#modal-global-menuハッシュを削除
    const url = new URL(window.location.href)
    url.searchParams.delete('event')
    if (url.hash.startsWith('#modal-global-menu')) {
      url.hash = ''
    }
    history.replaceState(null, '', url.toString())
  }

  // イベントを要素に対してアクションする
  bindEvent() {
    this.items.forEach(element => {
      const trigger = element.querySelector('.js-modal-menu-trigger')
      const modal = element.querySelector('.js-modal-menu-content')
      const closeBtn = element.querySelector('.js-modal-menu-close')

      trigger.addEventListener('click', e => {
        e.preventDefault()
        this.openModal(modal)
        // Clarity: モーダルトラッキングを更新
        const modalUrl = new URL(window.location.href)
        modalUrl.searchParams.set('event', 'claritymodal')
        modalUrl.hash = 'modal-global-menu'
        history.pushState(null, '', modalUrl.toString())
      })
      closeBtn.addEventListener('click', e => {
        e.preventDefault()
        this.closeModal(
          modal,
          e.currentTarget.classList.contains(this.MODAL_ROOT_CLOSE)
        )
      })
      this.overlay.addEventListener('click', e => {
        e.preventDefault()
        this.closeModal(modal, true)
      })
    })
  }
}
export default ModalMenu
